import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { sortBy } from 'lodash';
import { Dictionary } from 'src/app/core/model/dictionary';

@Component({
  selector: 'app-formly-field-multi-select',
  templateUrl: './formly-field-multi-select.component.html',
  styleUrls: ['./formly-field-multi-select.component.scss']
})
export class FormlyFieldMultiSelectComponent extends FieldType 
{
  public dictionary = undefined;
  public searchTerm = '';
  public filtered: any = [];
  public virtualDropdown: any = {
    itemHeight: 30
  };

  constructor(
    private dictionaryService: DictionaryService,
    private messageHandlerService: MessageHandlerService)
  {
    super();
    setTimeout(() =>
    {
      this.dictionary = undefined;
      if (this.field && this.field.templateOptions) 
      {
        if (this.field.templateOptions.codeSetId) 
        {
          this.dictionaryService.getCachedCodesByCodeSetId(this.field.templateOptions.codeSetId).subscribe({
            next: (data) =>
            {
              this.dictionary = sortBy(data, ['displayName']);
              // Must call set value to make sure the display name is shown
              this.formControl.setValue(this.formControl.value);
              this.formControl.updateValueAndValidity();
              this.filterDictionary('');
            },
            error: (error) =>
            {
              this.messageHandlerService.displayError(error);
            }
          });
        }
        else
        {
          this.filtered = this.field.templateOptions.options;
          this.filterText('', this.filtered);
        }
      }
    });
  }

  public filterDictionary(filter: string): void
  {
    this.searchTerm = filter;
    this.filtered = this.dictionary
      .filter((v: Dictionary) => v.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  public filterText(filter: string, options: []): void
  {
    this.searchTerm = filter;
    this.filtered = options
      .filter((v: any) => v.label.toLowerCase().includes(filter.toLowerCase()));
  }
}
